export * from './modal'
export * from './login'
export * from './course'
export * from './home'
export * from './search'
export * from './setting'
export * from './profile'
export * from './player'
export * from './route'
export * from './signup'
export * from './creator'
export * from './creatorDashboard'
export * from './newCourse'
export * from './contact'
export * from './verify'
export * from './uploadCourse'
export * from './instructor'
export * from './step'
export * from './province'
export * from './contactstaff'
export * from './courseOneByOne'
export * from './example'
export * from './addNewCourse'
export * from './coinStore'
export * from './banner'
export * from './live'
export * from './schedule'



// WEBPACK FOOTER //
// ./src/actions/index.js